import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutSalesCallMultiSelectErrorModal extends Layout {
    labelFailedLink: Label;
    labelFailedOrderCount: Label;
    labelFailedOrders: Label;
    labelFailedPipe: Label;
    labelStatus: Label;
    labelSuccessfulOrderCount: Label;
    labelSuccessfulOrders: Label;
    panelFailed: Panel;
    panelSuccess: Panel;
}
